

import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'

export const WTPWaterQualityDataUploadPageExcelExport = (props) => {
    const { ExcelData, name, FromDate, ParameterID } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExportWaterQuality"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExportWaterQuality" style={{ display: 'none', width: '46%' }}>

                <h5><span>&emsp;</span></h5>

                <tr >
                    <th>Navi Mumbai Muncipal Corporation</th>
                </tr>
                {/* <tr style={{ border: '1px solid black' }}>
                    <th colSpan={8} style={{ textAlign: 'center', fontSize: 16 }}>Sewerage Maintenance Department</th>
                </tr> */}

                <tr >
                    <th>Report Name - {name}</th>
                </tr>

                <tr >
                    <th>Parameter Name - {ParameterID.Label}</th>
                </tr>

                <tr >
                    <th>
                        Report Date - {FromDate ? moment(FromDate).format('DD-MM-YYYY') : '-'}
                    </th>
                </tr>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>

                        <th className="sr_no_col">Sr No.</th>
                        <th>Parameter</th>
                        <th>Date</th>
                        <th>Time</th>
                        {
                            (ParameterID.ID == 28 || ParameterID.ID == 29 || ParameterID.ID == 30 || ParameterID.ID == 31) &&
                            <>
                                <th>Raw Water</th>
                                <th>Settled Water</th>
                                <th>Filtered Water</th>
                                <th>Pure Water</th>
                            </>
                        }

                        {
                            ParameterID.ID == 32 &&
                            <th>Lit/Hrs</th>
                        }

                        {
                            ParameterID.ID == 33 &&
                            <>
                                <th>Lit/Hrs</th>
                                <th>PPM</th>
                            </>
                        }

                        {
                            (ParameterID.ID == 34 && ParameterID.ID == 35) &&
                            <>
                                <th>Kg/Hrs</th>
                                <th>PPM</th>
                            </>
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.length > 0 ? ExcelData.map((j, i) => {
                            return (
                                <tr style={{ border: '0.5px solid black' }}>
                                    <td style={{ textAlign: "center" }}>{i + 1}</td>
                                    <td>{j?.waterQuality_IndicatorName}</td>
                                    <td>{j?.readingDate ? moment(j?.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                    <td>{j?.timeValue}</td>
                                    {
                                        (ParameterID.ID == 28 || ParameterID.ID == 29 || ParameterID.ID == 30 || ParameterID.ID == 31) &&
                                        <>
                                            <td>{j?.rawWater}</td>
                                            <td>{j?.settledWater}</td>
                                            <td>{j?.filteredWater}</td>
                                            <td>{j?.pureWater}</td>
                                        </>
                                    }

                                    {
                                        ParameterID.ID == 32 &&
                                        <td>{j?.literHours}</td>
                                    }

                                    {
                                        ParameterID.ID == 33 &&
                                        <>
                                            <td>{j?.literHours}</td>
                                            <td>{j?.ppm}</td>
                                        </>
                                    }

                                    {
                                        (ParameterID.ID == 34 && ParameterID.ID == 35) &&
                                        <>
                                            <td>{j?.kgHours}</td>
                                            <td>{j?.ppm}</td>
                                        </>
                                    }
                                </tr>
                            )
                        })
                            : <td colSpan={15}>No data found</td>
                    }

                </tbody>
            </table>
        </div>
    )
}